import { ApiAdress } from '../components/GlobalSettings';
import axios from "axios";
import qs from "qs";
const headers = {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
};
const PageOrderSave= async(OldPageID,OldNo,NewPageID,NewNo)=>{
const OldUpdate=await UpdatePageNumber(OldPageID,OldNo);
const newUpdate=await UpdatePageNumber(NewPageID,NewNo)
return (OldUpdate&&newUpdate)?true:false
}

const UpdatePageNumber=async(PageID,NewNo)=>{
    const data = qs.stringify({
        PageID: PageID,
        No: NewNo
    })

    const result = await axios.post(ApiAdress + 'api/page/Pages/PageOrder', data, headers)
        .then((res) => {
            return (res.status == 500) ? true : false
        }).catch((err) => {
            console.log("Hata", err)
            return false;
        })

        return result;
}

const PagePreviewOnOff=async(PageID,Prev)=>{
    
    const data = qs.stringify({
        Id: PageID,
        Prev: Prev
    });
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/Prev', data, headers)
        .then((res) => {

console.log("Ne Oldu Burada ",res)
            if (res.data.sonuc == "Başarılı") {
return true
            }
        })
        .catch((err) => {
            console.log("Hata", err)
            return false
        });

        return PageData
}

const PageFrontTitleOnOff = async (PageID, FrontTitle) => {

    console.log("FrontTitle",PageID+" "+FrontTitle)
    const data = qs.stringify({
        Id: PageID,
        FrontTitle: FrontTitle
    });
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/FrontTitle', data, headers)
        .then((res) => {


            if (res.data.sonuc == "Başarılı") {
                return true
            }
        })
        .catch((err) => {
            console.log("Hata", err)
            return false
        });

    return PageData
}

const PageShowMainOnOff = async (PageID, ShowMain) => {

    console.log("Yollandı title")
    const data = qs.stringify({
        Id: PageID,
        ShowMain: ShowMain
    });
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/ShowMain', data, headers)
        .then((res) => {


            if (res.data.sonuc == "Başarılı") {
                return true
            }
        })
        .catch((err) => {
            console.log("Hata", err)
            return false
        });

    return PageData
}


const AddShortText = async (PageID, ShortText) => {

    console.log("Yollandı title")
    const data = qs.stringify({
        PageID: PageID,
        ShortText: ShortText
    });
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/AddShortText', data, headers)
        .then((res) => {


            if (res.data.sonuc == "Başarılı") {
                return true
            }
        })
        .catch((err) => {
            console.log("Hata", err)
            return false
        });

    return PageData
}


const PagePropertiesUpdate=async(Properties)=>{
    console.log("Properties",Properties)
    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', Properties.soundFile);
    formData.append('IssueID', Properties.QIssueID)
    formData.append('PageName', Properties.name)
    formData.append('eSubPageName', Properties.subtitle)
    formData.append('PageID', Properties.id)
    formData.append('eAuthor', Properties.author)
    formData.append('SoundTime', Properties.soundTime)
    
    const UpdatePost=await axios.post(ApiAdress + 'api/page/Pages/PageUpdateProperties',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc == 'Başarılı') {
                
                
                return "Ok"
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err)=>{
            console.log(err)
    return "Proplem"
    
}
        )

        return UpdatePost
}
const PageImageUpload = async (ImageFile, PageID, QIssueID) => {
    


    
    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)

    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/PageImageUpload',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc !=null) {

                console.log("ImageResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost

    
}

const ImageUpload = async (ImageFile, PageID, QIssueID) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)

    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/ImageFileUpload',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("ImageResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}



const PageDelete=async(PageID)=>{
    const data = qs.stringify({
        Id: PageID
    })
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/PageDelete',
     data, headers)
     .then((res)=>{
         console.log("res",res)
         if(res.data.sonuc == "Başarılı")
         {
             return "Ok"
         }
     })
     .catch((err)=>{
         console.log("err",err)
return err
     })
     return PageData

}

const CreatePage=async(PageData)=>{
    const formData = new FormData(); 
    const headers1 = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    
    formData.append('myfile', "");
    formData.append('IssueID', PageData.QIssueID)
    formData.append('PageName', PageData.name)
    formData.append('eSubPageName', PageData.subtitle)
    formData.append('PageID', "0")
    formData.append('eAuthor', PageData.author)
    const postData=await axios.post(ApiAdress + 'api/page/Pages/NewPage',
        formData, headers1).then((response) => {
            return "Ok"
        }).catch((err) => { console.log('Hata Oluştu : ' + err) })
return postData
}

const GetAllPageByIssueID=async(IssueID)=>{
   
    const data = qs.stringify({
        ByAuthor: "Yazar Bilgisi",
        IssueID: IssueID
    })

    
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/ByEditor', data, headers)
        .then((res) => {
            console.log("ipadres", ApiAdress)
        console.log("Gelen Pages Datası",res.data)
            return res.data
        })
        .catch((err)=>{
            console.log("ipadres",ApiAdress)
            console.log("Sayfaları çekerken hata oluştu ",err)
            return ""
            
        })
        return PageData;
}

const GetPageImage=async(PageID)=>{
    const data = qs.stringify({
        PageID: PageID
    })
    const PageImages = await axios.post(ApiAdress + 'api/page/Pages/ImageLists', data, headers).then((res)=>{
        return res.data
    })
return PageImages

}


const UpdatePageName = async (PageID, NewName) => {
    const data = qs.stringify({
        PageID: PageID,
        NewName: NewName
    })
    const responseResult = await axios.post(ApiAdress + 'api/page/Pages/UpdatePageName', data, headers).then((res) => {
        return res
    })
    return responseResult

}
const UpdateSubTitle = async (PageID, NewName) => {
    const data = qs.stringify({
        PageID: PageID,
        NewName: NewName
    })
    const responseResult = await axios.post(ApiAdress + 'api/page/Pages/UpdateSubTitle', data, headers).then((res) => {
        return res
    })
    return responseResult

}
const UpdateYazar = async (PageID, NewName) => {
    const data = qs.stringify({
        PageID: PageID,
        NewName: NewName
    })
    const responseResult = await axios.post(ApiAdress + 'api/page/Pages/UpdateYazar', data, headers).then((res) => {
        return res
    })
    return responseResult

}
const PageSave=async(PageID,Layout,PageCss,PageName,FullLayout,RawData,RawCss)=>{
    const data = qs.stringify({
        Id: PageID,
        Layout: Layout,
        ThumbUrl: "ThumbUrl",
        PageStyle: PageCss,
        PageName: PageName,
        FullLayout: FullLayout,
        RawData: RawData,
        RawCss: RawCss
    });

    const SavePost = await axios
        .post(ApiAdress + "api/page/Pages/PageUpdate",
            data, headers)
        .then((res) => {
            if (res.data.sonuc == "Başarılı") {
                return true
            }
        })
        .catch((err) => {
            console.log("hata", err);
        });

        return SavePost
}

const GetPageByID = async (PageID) => {
    const data = qs.stringify({
        PageID: PageID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/BypageID', data, headers).then((res) => {
        return res.data
    })
    console.log("Ne geldi",PageDetail)
    return PageDetail

}


const getImageListByPAge = async (PageID) => {
    
    const data = qs.stringify({
        PageID: PageID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/ImageLists', data, headers).then((res) => {
        
        return res.data
    })
    return PageDetail

}
const Deployment = async (IssueID)=>{
    const data = qs.stringify({
        IssueID: IssueID,
    });
    const PageData = await axios
        .post(ApiAdress + "api/page/Pages/Revize", data, headers)
        .then((res) => {
           
            return true;
        })
        .catch((err) => {
            console.log("Hata", err);
            return false
        });

        return PageData

}

const VideoUpdate = async (ImageFile, PageID, QIssueID, VideoID) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/UpdateVideo',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const VideoAdd = async (ImageFile, PageID, QIssueID, VideoID) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/AddVideo',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const VideoDelete = async (videoID) => {
    const data = qs.stringify({
        Id: videoID
    })
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/VideoDelete',
        data, headers)
        .then((res) => {
            console.log("res", res)
            if (res.data.sonuc == "Başarılı") {
                return "Ok"
            }
        })
        .catch((err) => {
            console.log("err", err)
            return err
        })
    return PageData

}
const GetVideoList = async (IssueID) => {
    const data = qs.stringify({
        IssueId: IssueID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/videolist', data, headers).then((res) => {
        return res.data
    })
    return PageDetail

}
const GetSoundList = async (IssueID) => {
    const data = qs.stringify({
        IssueId: IssueID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/soundlist', data, headers).then((res) => {
        return res.data
    })
    return PageDetail

}


const DeleteSoundOnPage = async (PageID) => {


console.log("Silme PageID ",PageID)

    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
   
    formData.append('IssueID', 0)
    formData.append('PageID', PageID)
   
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/DeleteSoundOnPage',
        formData, PropHeaders).then((response) => {
            console.log("Silme Response ",response)
            if (response.data.sonuc != null) {

                console.log("SoundUpdateOnPage", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Ses Ekleme Sırasında Hata Oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const UpdateSoundPage = async (SoundFile, PageID, QIssueID, SoundTime) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', SoundFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('SoundTime', SoundTime)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/UpdateSoundPage',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("SoundUpdateOnPage", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Ses Güncelleme Sırasında Hata Oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}



const SoundUpdate = async (ImageFile, PageID, QIssueID, VideoID,Owner) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    formData.append('Owner', Owner)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/UpdateSound',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const SoundAdd = async (ImageFile, PageID, QIssueID, VideoID,Owner) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    formData.append('Owner', Owner)
    console.log("OWnerrrr",Owner)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/SoundVideo',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const SoundDelete = async (videoID) => {
    const data = qs.stringify({
        Id: videoID
    })
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/SoundDelete',
        data, headers)
        .then((res) => {
            console.log("res", res)
            if (res.data.sonuc == "Başarılı") {
                return "Ok"
            }
        })
        .catch((err) => {
            console.log("err", err)
            return err
        })
    return PageData

}

const SoundOwnerUpdate = async (PageID, Owner) => {
    const data = qs.stringify({
        Id: PageID,
        Owner: Owner
    })
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/SoundOwnerUpdate',
        data, headers)
        .then((res) => {
            console.log("res", res)
            if (res.data.sonuc == "Başarılı") {
                return "Ok"
            }
        })
        .catch((err) => {
            console.log("err", err)
            return err
        })
    return PageData

}
const SlideAdd = async (ImageFile, PageID, QIssueID, VideoID) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/AddSlide',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const SlideUpdate = async (ImageFile, PageID, QIssueID, VideoID) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('myfile', ImageFile);
    formData.append('IssueID', QIssueID)
    formData.append('PageID', PageID)
    formData.append('VideoID', VideoID)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/UpdateSlide',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("VideoResult", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}
const SlideDelete = async (videoID) => {
    const data = qs.stringify({
        Id: videoID
    })
    const PageData = await axios.post(ApiAdress + 'api/page/Pages/SlideDelete',
        data, headers)
        .then((res) => {
            console.log("res", res)
            if (res.data.sonuc == "Başarılı") {
                return "Ok"
            }
        })
        .catch((err) => {
            console.log("err", err)
            return err
        })
    return PageData

}
const GetSlideList = async (IssueID) => {
    const data = qs.stringify({
        IssueId: IssueID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/SlideList', data, headers).then((res) => {
        return res.data
    })
    return PageDetail

}

const SosialAdd = async (IssueID, PageID, FacebookLink, TwitterLink, InstLink) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('IssueID', IssueID);
    formData.append('PageID', PageID)
    formData.append('FacebookLink', FacebookLink)
    formData.append('TwitterLink', TwitterLink)
    formData.append('InstLink', InstLink)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/AddSosial',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("Sosial", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}
const SosialUpdate = async (IssueID, PageID, FacebookLink, TwitterLink, InstLink) => {




    const PropHeaders = {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data"
    };
    const formData = new FormData();
    formData.append('IssueID', IssueID);
    formData.append('PageID', PageID)
    formData.append('FacebookLink', FacebookLink)
    formData.append('TwitterLink', TwitterLink)
    formData.append('InstLink', InstLink)
    const UpdatePost = await axios.post(ApiAdress + 'api/page/Pages/UpdateSosial',
        formData, PropHeaders).then((response) => {
            if (response.data.sonuc != null) {

                console.log("Sosial", response.data.sonuc)
                return response.data.sonuc
            }
            else {
                console.log('Sayfa güncelleme sırasında hata oluştu', response.data)
                return "Proplem"
                //alert('Sayfa güncelleme sırasında hata oluştu')
            }
        }).catch((err) => {
            console.log(err)
            return "Proplem"

        }
        )

    return UpdatePost


}

const GetSosialList = async (IssueID) => {
    const data = qs.stringify({
        IssueId: IssueID
    })
    const PageDetail = await axios.post(ApiAdress + 'api/page/Pages/sosiallist', data, headers).then((res) => {
        return res.data
    })
    return PageDetail

}

const GlobalUrl = ApiAdress;
export {
    PageOrderSave,
    PagePreviewOnOff,
    PagePropertiesUpdate,
    PageDelete,
    CreatePage,
    GetAllPageByIssueID,
    PageSave,
    Deployment,
    GetPageImage,
    PageFrontTitleOnOff,
    PageShowMainOnOff,
    PageImageUpload,
    GlobalUrl,
    GetPageByID,
    GetVideoList,
    VideoUpdate,
    VideoAdd,
    VideoDelete,
    SoundUpdate,
    SoundAdd,
    SoundDelete,
    GetSoundList,
    SlideAdd,
    SlideUpdate,
    SlideDelete,
    GetSlideList,
    ImageUpload,
    getImageListByPAge,
    SosialAdd,
    SosialUpdate,
    GetSosialList,
    AddShortText,
    UpdateSoundPage,
    DeleteSoundOnPage,
    UpdatePageName,
    UpdateSubTitle,
    UpdateYazar,
    SoundOwnerUpdate
    
}